import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Form, Input, Space, Typography } from 'antd';
import { useForgotPasswordWithLoginIdNew } from 'all-in-one-shared-api';
// import { InfoCircleOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
// import forgotIcon from 'assets/images/reset-icon.svg';
import { VStack } from 'components';
// import { loginIdRegex } from 'utils/regex';
import generateKey from 'utils/generateKey';
import { useContext } from 'react';
import { ForgotPasswordData } from './forgotPasswordData';
import PolicyAndMemberIdModal from './PolicyAndMemberIdModal';
// import { Wrapper } from 'pages/life/forget/styledComponents';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
import { setErrorCodeFun } from '../../../utils';
import { ActionType, RegistrationFlowContext, RegistrationFormData } from 'contexts/registration';
import './style.less';
import { useMediaQuery } from 'react-responsive';
function ForgotPasswordPage() {
  const isLargeScreen = useMediaQuery({ minWidth: 768 });
  const { dispatch } = useContext(RegistrationFlowContext);
  const { t, i18n } = useTranslation();
  const [formDataState, setFormDataState] = React.useState<ForgotPasswordData>({
    selfDefinedLoginId: '',
  });
  const navigate = useNavigate();
  const [forgotPasswordWithLoginKey, setForgotPasswordWithLoginKey] = React.useState<string>('');
  // const [forgotPasswordWithMemberIdKey, setForgotPasswordWithMemberIdKey] = React.useState<string>('');

  // const [method, setMethod] = React.useState('loginId');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [emailFlag, setEmailFlag] = useState(false);
  const [mobileFlag, setMobileFlag] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [note, setNote] = useState('');
  const [form] = Form.useForm();
  const [errmessage, setErrmessage] = useState<string | null>(null);
  // const [errors, setErrors] = useState<string | null>(null);
  useEffect(() => {
    console.log('popUp', popUp);
    if (popUp) {
      const mask = document.createElement('div');
      mask.className = 'mask_custom';
      mask.style.position = 'fixed';
      mask.style.height = '100%';
      mask.style.width = '100%';
      mask.style.top = '0';
      mask.style.left = '0';
      mask.style.zIndex = '130';
      mask.style.backgroundColor = 'rgba(0,0,0,.2)';
      mask.style.display = 'flex'; // 使用 flex 布局
      mask.style.justifyContent = 'center'; // 水平居中
      mask.style.alignItems = 'center'; // 垂直居中

      const content = document.createElement('div');
      content.style.background = 'white';
      content.style.paddingLeft = '24px';
      content.style.paddingRight = '24px';
      content.style.paddingTop = '14px'; // 上方留出空间
      // content.style.paddingBottom = '10px'; // 下方留出空间
      content.style.borderRadius = '8px';
      content.style.height = 'auto'; // 根据内容调整高度
      content.style.width = '420px'; // 给定宽度
      // content.style.textAlign = 'center'; // 让内容居中

      const tipText = document.createElement('span');
      tipText.style.fontFamily = 'Roboto400';
      tipText.style.fontSize = '18px'; // 增大字号
      tipText.style.color = '#6F7072';
      tipText.style.marginBottom = '12px'; // 增加下边距，使其与内容分开
      tipText.style.textAlign = 'center'; // 居中显示
      tipText.innerText = t('life.register.Quicktip');

      const noteText = document.createElement('p');
      noteText.style.fontFamily = 'Roboto400';
      noteText.style.fontSize = '17px';
      noteText.style.color = '#420252B';
      noteText.style.marginTop = '16px'; // 增加下边距
      noteText.style.marginBottom = '16px'; // 增加下边距
      if (note == 'A') {
        noteText.innerText = t('life.home.note3');
      } else if (note == 'B') {
        noteText.innerText = t('life.home.note');
      } else if (note == 'C') {
        noteText.innerText = t('life.home.note2');
      } else if (note == 'D') {
        noteText.innerText = t('life.home.note1');
      }
      const closeButton = document.createElement('p');
      closeButton.style.fontSize = '17px';
      closeButton.style.color = '#420252B';
      closeButton.style.marginTop = '10px'; // 上边距避免与内容重叠
      closeButton.style.cursor = 'pointer'; // 鼠标悬浮时显示为手形
      closeButton.style.textAlign = 'right';
      closeButton.innerText = i18n.language === 'en' ? 'close' : '關閉';
      closeButton.onclick = () => {
        setPopUp(false);
        // 移除遮罩层
        document.body.removeChild(mask);
        if (note != 'B' && note != 'D') {
          if (emailFlag) {
            navigate('/forgot/ForgotPasswordWithEmailPage', { replace: true });
          } else if (mobileFlag) {
            navigate('/forgot/ForgotPasswordWithMobilePage', { replace: true });
          }
        }
      };

      content.appendChild(tipText);
      content.appendChild(noteText);
      content.appendChild(closeButton);

      mask.appendChild(content);
      document.body.appendChild(mask);
    }
    //eslint-disable-next-line
  }, [popUp, t, i18n.language]);
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);

  const {
    shouldFetch: shouldforgotPasswordWithLoginFetch,
    // data: forgotPasswordWithLoginData,
    error: forgotPasswordWithLoginError,
    isLoading,
  } = useForgotPasswordWithLoginIdNew(
    forgotPasswordWithLoginKey,
    {
      loginId: formDataState.selfDefinedLoginId ?? '',
    },
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      onSuccess: (data) => {
        shouldforgotPasswordWithLoginFetch(false);
        if (data && data.ebExpireFlag == 'Y') {
          //eb+life 且eb过期 Y
          setNote('A');
          setEmailFlag(data.emailFlag);
          setMobileFlag(data.mobileFlag);
          setPopUp(true);
        } else if (data && data.lifeExpireFlag == 'Y') {
          //单life 且life过期 Y 无法跳转下一页
          setNote('B');
          setEmailFlag(data.emailFlag);
          setMobileFlag(data.mobileFlag);
          setPopUp(true);
        } else if (data && data.lifeExpireFlag == 'Z') {
          //eb+life 且life过期 Z
          setNote('C');
          setEmailFlag(data.emailFlag);
          setMobileFlag(data.mobileFlag);
          setPopUp(true);
        } else if (data && data.ebExpireFlag == 'Z') {
          //單eb 且eb过期 Z
          setNote('D');
          setEmailFlag(data.emailFlag);
          setMobileFlag(data.mobileFlag);
          setPopUp(true);
        } else {
          if (data && data.emailFlag) {
            navigate('/forgot/ForgotPasswordWithEmailPage', { replace: true });
          } else if (data && data.mobileFlag) {
            navigate('/forgot/ForgotPasswordWithMobilePage', { replace: true });
          }
        }

        // setStartLoading(false);
      },
      onError: (err) => {
        // setStartLoading(false);
        // const message = setErrorCodeFun(err.code, i18n.language);
        console.log('err', err);
        // setErrmessage(err);
      },
    },
  );

  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  const closeModel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    //单eb 且eb失效 报错
    // if (forgotPasswordWithLoginError?.code && forgotPasswordWithLoginError?.message) {
    //   const message = setErrorCodeFun(forgotPasswordWithLoginError.code, i18n.language);
    //   setErrors(forgotPasswordWithLoginError.code);
    //   setErrmessage(message);
    // }
    if (i18n.language && forgotPasswordWithLoginError) {
      const message = setErrorCodeFun(
        forgotPasswordWithLoginError.code ?? forgotPasswordWithLoginError.message,
        i18n.language,
      );
      setErrmessage(message);
    }
  }, [i18n.language, forgotPasswordWithLoginError]);

  // useEffect(() => {
  //   console.log('state ----idpage', state);
  // }, [state]);
  // useEffect(() => {
  //   console.log('formDataState', formDataState);
  // }, [formDataState]);
  const onValidateSuccessful = React.useCallback(
    (data: RegistrationFormData, event?: React.BaseSyntheticEvent) => {
      console.log('validatesuccessful', 'data:', data);
      event && event.preventDefault();
      dispatch({ type: ActionType.UpdateFormData, payload: data });
      // if (method === "loginId") {
      setForgotPasswordWithLoginKey(generateKey);
      shouldforgotPasswordWithLoginFetch(true);
    },
    [dispatch, shouldforgotPasswordWithLoginFetch],
  );

  // Note(Anson Kan): I don't know how to type return values from `antd` `Form`...
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onFinish = (values: any) => {
    console.log('finish', 'values', values);
    // navigate("/forgot/ForgotPasswordWithEmailPage"); //提交时注释掉
    // setFormDataState({
    //   // email: values.email,
    //   selfDefinedLoginId: values.selfDefinedLoginId,
    //   // memberId: values.memberId && values.memberId.toString(),
    //   // policyNumber: values.memberId && values.policyNumber.toString(),
    // });
    onValidateSuccessful(formDataState);
    // onValidateSuccessful(formDataState);
  };
  const isLoginIdValid = formDataState.selfDefinedLoginId?.trim() !== '';

  // useEffect(() => {
  //   if (formDataState.selfDefinedLoginId) {
  //     // 确保formDataState更新后才执行
  //   }
  // }, [formDataState, onValidateSuccessful]);
  // const infoIcon = <InfoCircleOutlined onClick={showModal} style={{ cursor: 'pointer' }} />;
  // useEffect(() => {
  //   if (forgotPasswordWithLoginData && forgotPasswordWithLoginData.emailFlag) {
  //     navigate('/forgot/ForgotPasswordWithEmailPage', { replace: true });
  //   } else if (forgotPasswordWithLoginData && forgotPasswordWithLoginData.mobileFlag) {
  //     navigate('/forgot/ForgotPasswordWithMobilePage', { replace: true });
  //   }
  //   shouldforgotPasswordWithLoginFetch(false);
  // }, [forgotPasswordWithLoginData, navigate, shouldforgotPasswordWithLoginFetch]);
  useEffect(() => {
    dispatch({ type: ActionType.ClearForm });
    // eslint-disable-next-line
  }, []);
  return (
    <div
      className="forgot_wrapper"
      style={{
        paddingLeft: isLargeScreen ? '40px' : '0',
        paddingRight: isLargeScreen ? '40px' : '0',
      }}
    >
      <Typography.Title
        level={3}
        style={{ fontSize: '33px', fontFamily: 'Roboto400', color: '#fff', fontWeight: '400' }}
      >
        {t('life.forgetLoginId.ForgotPassword')}{' '}
      </Typography.Title>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          paddingBottom: '200px',
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '0',
            border: '0',
            width: isLargeScreen ? '50%' : '100%', // 根据屏幕大小动态调整宽度
            padding: '20px',
          }}
        >
          <VStack>
            <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}>
              {t('forgetPassword.description')}
            </Typography.Text>
            <Space style={{ marginTop: 16, marginBottom: 16 }}>
              {/* <Typography.Text>{t("forgetPassword.instruction")}</Typography.Text> */}
            </Space>
          </VStack>

          <Form
            layout={'vertical'}
            form={form}
            style={{ marginTop: 16, fontSize: '17px', fontFamily: 'Roboto400' }}
            onFinish={onFinish}
            requiredMark="optional"
            validateTrigger={false}
            onChange={() => {
              // 获取当前所有字段的值
              const formValues = form.getFieldsValue();

              // 如果 selfDefinedLoginId 有变化，则更新 formDataState
              if (formValues.selfDefinedLoginId !== undefined) {
                setFormDataState({ selfDefinedLoginId: formValues.selfDefinedLoginId });
              }
            }}
          >
            <Form.Item
              label={
                <span style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}>
                  {t('forgetPassword.loginIdLabel')}
                </span>
              }
              name="selfDefinedLoginId"
              rules={[
                { required: true, message: t('registration.error.required') },
                // () => ({
                //   validator(_, value) {
                //     if (!value || (loginIdRegex.test(value) && value.length >= 6)) {
                //       return Promise.resolve();
                //     }
                //     return Promise.reject(new Error(t('registration.error.invalidLoginId')));
                //   },
                // }),
              ]}
              style={{ marginBottom: 12 }}
            >
              <Input
                size="middle"
                placeholder={t('forgetPassword.loginIdPlaceholder')}
                style={{
                  border: 'none',
                  paddingLeft: 0,
                  borderBottom: '1px solid #E5E5E5',
                  // color: "white",
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  backgroundColor: 'transparent',
                }}
                maxLength={20}
              />
              {/* <Input maxLength={20} size="middle" placeholder={t('forgetPassword.loginIdPlaceholder')} /> */}
            </Form.Item>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                // backgroundColor: 'pink',
              }}
            >
              <Link
                style={{
                  fontSize: '17px',
                  fontFamily: 'Roboto400',
                  marginLeft: 4,
                  marginRight: 4,
                  color: '#C21B17',
                  textDecoration: 'underline',
                }}
                to="/forgot/login"
              >
                {t('login.forgetSelfDefinedIdLabel')}
              </Link>
              <Form.Item style={{ width: '80%' }}>
                {errmessage && (
                  <Alert
                    message={errmessage}
                    type="error"
                    className="custom-alert"
                    style={{
                      marginTop: 16,
                      border: 'none',
                    }}
                  />
                )}
                <Button
                  block
                  type="primary"
                  loading={isLoading}
                  size="large"
                  htmlType="submit"
                  disabled={!isLoginIdValid} // 禁用条件
                  style={{
                    marginTop: 24,
                    fontFamily: 'Roboto500',
                    fontSize: '20px',
                    height: '56px',
                    width: '100%',
                  }}
                >
                  {t('common.submit')}
                </Button>
              </Form.Item>
              {/* <Link
                style={{
                  fontWeight: 'normal',
                  marginLeft: 4,
                  marginRight: 4,
                  color: '#C21B17',
                  textDecoration: 'underline',
                }}
                to="/forgot/login"
                onClick={(e) => e.preventDefault()}
              >
                {t('forgetLoginId.help')}
              </Link> */}
            </div>
          </Form>
        </div>
      </div>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </div>
  );
}

export default ForgotPasswordPage;
